import * as React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Button,
  CssBaseline,
  TextField,
  Box,
  Typography,
  Container,
  Card,
  CardContent,
  useTheme,
} from "@mui/material";
import TransMexLogo from "../../../assets/TransMexLogo-Final_CMYK.png";
import { GET } from "../../Generic/CrudRequest";

export default function ForgotPassword(props) {
  const { t } = useTranslation();
  const [email, setEmail] = React.useState("");
  const [emailError, setEmailError] = React.useState("");
  const theme = useTheme();
  const navigate = useNavigate();
  const { config } = props;

  const handleForgotPassword = async () => {
    await GET(`${config.url}/api/User/forgot-password/${email}`);
    navigate("/Account/Login");
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (email === "") {
      setEmailError(t("account.forgotPassword.emailRequired"));
    }

    if (email !== "") {
      handleForgotPassword();
    }
  };

  return (
    <Card
      sx={{
        width: "fit-content",
        margin: "auto",
        marginTop: 20,
        maxWidth: "380px",
      }}
    >
      <CardContent>
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <img
            src={TransMexLogo}
            alt={t("navigation.logoAlt")}
            style={{ width: "290px", height: "70px", marginTop: "30px" }}
          />
          <Typography
            variant="h4"
            align="center"
            gutterBottom
            sx={{ mt: 1, textAlign: "center", marginTop: "30px" }}
          >
            {t("account.forgotPassword.title")}
          </Typography>
          <Typography variant="h5" align="center" gutterBottom>
            {t("account.forgotPassword.description")}
          </Typography>
          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{ mt: 1, textAlign: "center" }}
          >
            <TextField
              margin="normal"
              variant="standard"
              fullWidth
              sx={{ maxWidth: "300px" }}
              id="email"
                              label={t("account.forgotPassword.email")}
              name="email"
              autoComplete="email"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              error={!!emailError}
              helperText={emailError}
            />
            <Button
              type="submit"
              variant="contained"
              sx={{
                mt: 1,
                mb: 2,
                width: "150px",
                bgcolor: theme.palette.primary.main,
              }}
            >
              {t("account.forgotPassword.send")}
            </Button>
          </Box>
        </Container>
      </CardContent>
    </Card>
  );
}
